var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrainflix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "connection"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "page"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "support"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "configuration"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "cloud_storage"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "password"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "search_engine"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "history"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "SEO"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "optimization"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "backlink"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "performance"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "analytics"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "security"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "dark_web"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "video_player"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M91,13H9c-2.8,0-5,2.2-5,5v64c0,2.8,2.2,5,5,5h82c2.8,0,5-2.2,5-5V18C96,15.2,93.8,13,91,13z M9,15h82c1.7,0,3,1.3,3,3v7    H6v-7C6,16.3,7.3,15,9,15z M91,85H9c-1.7,0-3-1.3-3-3V27h88v55C94,83.7,92.7,85,91,85z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 20,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 20,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 20,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,30H12c-1.7,0-3,1.3-3,3v46c0,1.7,1.3,3,3,3h55c1.7,0,3-1.3,3-3V33C70,31.3,68.7,30,67,30z M68,79c0,0.6-0.4,1-1,1H12    c-0.6,0-1-0.4-1-1V33c0-0.6,0.4-1,1-1h55c0.6,0,1,0.4,1,1V79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,30H76c-1.7,0-3,1.3-3,3v10c0,1.7,1.3,3,3,3h12c1.7,0,3-1.3,3-3V33C91,31.3,89.7,30,88,30z M89,43c0,0.6-0.4,1-1,1H76    c-0.6,0-1-0.4-1-1V33c0-0.6,0.4-1,1-1h12c0.6,0,1,0.4,1,1V43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,48H76c-1.7,0-3,1.3-3,3v10c0,1.7,1.3,3,3,3h12c1.7,0,3-1.3,3-3V51C91,49.3,89.7,48,88,48z M89,61c0,0.6-0.4,1-1,1H76    c-0.6,0-1-0.4-1-1V51c0-0.6,0.4-1,1-1h12c0.6,0,1,0.4,1,1V61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,66H76c-1.7,0-3,1.3-3,3v10c0,1.7,1.3,3,3,3h12c1.7,0,3-1.3,3-3V69C91,67.3,89.7,66,88,66z M89,79c0,0.6-0.4,1-1,1H76    c-0.6,0-1-0.4-1-1V69c0-0.6,0.4-1,1-1h12c0.6,0,1,0.4,1,1V79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6,51.7l-17.1-10c-1.6-0.9-3.4-0.9-5,0C26.9,42.5,26,44.2,26,46v20c0,1.8,0.9,3.4,2.5,4.3c0.8,0.4,1.6,0.7,2.5,0.7    c0.9,0,1.7-0.2,2.5-0.7l17.1-10c1.5-0.9,2.5-2.5,2.5-4.3S52.2,52.6,50.6,51.7z M49.6,58.6l-17.1,10c-0.9,0.6-2.1,0.6-3,0    C28.6,68.1,28,67.1,28,66V46c0-1.1,0.6-2.1,1.5-2.6c0.5-0.3,1-0.4,1.5-0.4c0.5,0,1,0.1,1.5,0.4l17.1,10c0.9,0.5,1.5,1.5,1.5,2.6    S50.5,58,49.6,58.6z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "upload_download"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "incognito_tab"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "bookmark"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainflix);
export default __webpack_public_path__ + "static/media/brainflix.d0edf88576a93f805870d42177232aa6.svg";
export { ForwardRef as ReactComponent };